import { createNumberArray } from "../utils/index.js";
export function xSequentialFillFromStep(parameters, options = {}) {
    const { from, step, size } = parameters;
    const { ArrayConstructor = Float64Array } = options;
    const result = createNumberArray(ArrayConstructor, size);
    for (let i = 0; i < size; i++) {
        result[i] = from + i * step;
    }
    return result;
}
//# sourceMappingURL=xSequentialFillFromStep.js.map